import React, {
  type CSSProperties,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { useJetpackConfigSelector } from "../../redux/jetpackConfig";
import "./styles.scss";
import { tt } from "../../utils/i18n/i18n";

interface Props {
  iframeGameURL: string;
  id?: string;
}

const IFRAME_CONTAINER_WIDTH = 360;
const IPHONE_13_BORDER_RADIUS = 35;
const BORDER_WIDTH = 5;
const IPHONE_ASPECT_RATIO = 16 / 9;
const MAX_HEIGHT = Math.trunc(IFRAME_CONTAINER_WIDTH * IPHONE_ASPECT_RATIO);

export default function MobilePreview(props: Props) {
  const jetpackConfig = useJetpackConfigSelector();
  const previewContainerRef = useRef<HTMLDivElement | null>(null);

  const [src, setSrc] = useState("about:blank");

  const isMobile = useMemo(() => {
    // https://getbootstrap.com/docs/4.6/layout/overview/
    return window.innerWidth < 576;
  }, []);

  const iframeStyle = useMemo(() => {
    return {
      height: MAX_HEIGHT,
      maxHeight: MAX_HEIGHT
    };
  }, [previewContainerRef.current]);

  const containerStyle = useMemo<CSSProperties>(() => {
    return {
      border: BORDER_WIDTH + "px solid black",
      borderRadius: IPHONE_13_BORDER_RADIUS,
      overflow: "hidden",
      "--component-width": IFRAME_CONTAINER_WIDTH + "px",
      height: MAX_HEIGHT + BORDER_WIDTH + 5,
      maxHeight: MAX_HEIGHT + BORDER_WIDTH + 5,
      paddingBottom: 4
    };
  }, [iframeStyle]);

  useEffect(() => {
    if (!iframeStyle.height) {
      return;
    }

    const iframe = document.getElementById(
      "dashboard-game-type-iframe"
    ) as HTMLIFrameElement;

    if (iframe) {
      setSrc("about:blank");
      setTimeout(() => {
        setSrc(props.iframeGameURL);
      }, 300);
    }
  }, [iframeStyle, previewContainerRef, jetpackConfig, isMobile]);

  if (!props.iframeGameURL) {
    console.warn(
      "[MobilePreview] iframe not rendered because iframeGameURL is empty/falsy:",
      props.iframeGameURL
    );
  }

  return (
    <div className="d-flex flex-column flex-grow-0 align-items-center">
      <div className="mobile-preview-container" style={containerStyle}>
        {props.iframeGameURL && (
          <iframe
            id="dashboard-game-type-iframe"
            src={src}
            className="embed-responsive-item dashboard-game-type-selector__game-iframe w-100"
            style={iframeStyle}
          >
            <p>{tt("iframe_not_supported")}</p>
          </iframe>
        )}
      </div>
    </div>
  );
}
